// #228: the cart's "Complete the look" and "Community favourites" rows.
//
// The markup is snippets/cart-suggestions.liquid, rendered inside cart-items-component in the
// drawer (snippets/cart-drawer.liquid) and on /cart (sections/main-cart.liquid). This file is
// loaded with `defer` from layout/theme.liquid rather than inlined in the snippet: the drawer
// is re-rendered by morphing section HTML into the page, and a <script> arriving that way
// never runs.
(function () {
  if (window.__lsdCartSuggestionsBound) return;
  window.__lsdCartSuggestionsBound = true;

  var SOURCE = 'cart-suggestions';
  var ADDING_LABEL = 'Adding…';
  var ERROR_TEXT = "Couldn't add, try again";
  var SECTIONS = { complete_the_look: true, we_think_youll_love: true };
  var addInFlight = false;

  // window.lsdTrack (layout/theme.liquid) sends nothing until PostHog has loaded, which
  // happens only after analytics consent.
  function track(event, props) {
    try {
      if (window.lsdTrack) window.lsdTrack(event, props || {});
    } catch (e) {}
  }

  // For the "shown" events, which fire as a page loads or the drawer opens: PostHog loads
  // asynchronously after consent, so an event sent straight away is usually dropped. Wait for
  // it, bounded (30 x 500ms). Without consent it never loads and nothing is sent, as before.
  function trackWhenReady(event, props) {
    var tries = 0;
    (function attempt() {
      if (window.posthog && window.posthog.__loaded) {
        track(event, props);
        return;
      }
      if (++tries > 30) return;
      setTimeout(attempt, 500);
    })();
  }

  // Every section on the page that renders the cart, so ONE /cart/add.js round trip returns
  // all of them. The same collection as assets/cart-free-gift.js.
  function getSectionIds() {
    var ids = new Set();
    document.querySelectorAll('[data-section-id]').forEach(function (el) {
      var id = el.dataset.sectionId;
      if (id) ids.add(id);
    });
    return Array.from(ids).join(',');
  }

  // The ABSOLUTE count the header badge should show, read from the [ref="cartItemCount"] span
  // the server renders into the returned section HTML (snippets/cart-display-count.liquid
  // defines the rule; #150). Parsed with DOMParser, never searched for as a substring: the
  // drawer's own script text contains that selector. null when no section carries it, and
  // the event then goes out WITHOUT itemCount, which assets/cart-icon.js ignores rather
  // than reading as zero. /cart/add.js returns the added items, not the cart, so there is
  // no cart total to fall back on, and none is guessed.
  function countFromSections(sections) {
    try {
      for (var key in sections) {
        if (!Object.prototype.hasOwnProperty.call(sections, key)) continue;
        var html = sections[key];
        if (typeof html !== 'string') continue;
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[ref="cartItemCount"]');
        if (!el) continue;
        var n = parseInt(String(el.textContent).trim(), 10);
        if (!isNaN(n)) return n < 0 ? 0 : n;
      }
    } catch (e) {}
    return null;
  }

  // The #150 cart:update contract (snippets/cart-display-count.liquid; ThemeEvents.cartUpdate
  // in assets/events.js). Its own source, deliberately NOT 'product-form-component' (that
  // one makes assets/cart-icon.js ADD itemCount to the badge instead of setting it), and
  // deliberately not in assets/cart-drawer.js's AUTO_OPEN_SOURCES: the shopper is already
  // looking at the cart. component-cart-items.js morphs the cart from `sections`.
  function broadcast(sections, itemCount, sourceId) {
    var data = { source: SOURCE, sections: sections || {} };
    if (typeof itemCount === 'number') data.itemCount = itemCount;
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: {}, sourceId: sourceId, data: data }
      })
    );
  }

  // ── Announcements ──
  // In the drawer the region is the one cart-drawer.liquid renders INSIDE the dialog: while
  // the drawer is open everything outside it is inert, and the HTML standard ("inert subtrees")
  // says inert nodes are not exposed to accessibility APIs, so a region there would be silent. Everywhere else (/cart) it is this one, created on document.body, outside every
  // morphed section, so a cart re-render cannot remove it mid-announcement.
  var pageLive = null;
  function pageRegion() {
    if (pageLive && pageLive.isConnected) return pageLive;
    pageLive = document.createElement('div');
    pageLive.className = 'visually-hidden';
    pageLive.setAttribute('role', 'status');
    pageLive.setAttribute('aria-live', 'polite');
    pageLive.setAttribute('aria-atomic', 'true');
    document.body.appendChild(pageLive);
    return pageLive;
  }

  function regionFor(el) {
    var dialog = el && el.closest ? el.closest('dialog') : null;
    return (dialog && dialog.querySelector('[data-cart-suggestions-live]')) || pageRegion();
  }

  // Emptied first and written a beat later, so the same message twice in a row is still
  // announced; cleared after a few seconds so stale text is not left in the page.
  var clearTimer = null;
  function announce(region, message) {
    try {
      if (!region || !region.isConnected) region = pageRegion();
      if (clearTimer) clearTimeout(clearTimer);
      region.textContent = '';
      setTimeout(function () {
        region.textContent = message;
        clearTimer = setTimeout(function () {
          region.textContent = '';
        }, 7000);
      }, 100);
    } catch (e) {}
  }

  // An add re-renders the cart, and the product just added drops out of the suggestions, so
  // the button that had focus is gone. Put focus on that row's heading (or the block) rather
  // than leaving it on <body>.
  function refocus(placement, section) {
    try {
      var root = document.querySelector('[data-cart-suggestions][data-placement="' + placement + '"]');
      if (!root || root.hidden) {
        // The last suggestion was added and the block is now empty: keep focus inside the drawer
        // (or on the page's title) rather than letting it fall to <body> (#228 review).
        var fallback = placement === 'drawer'
          ? document.getElementById('cart-drawer-heading')
          : document.querySelector('.cart-page__title');
        if (fallback) {
          if (!fallback.hasAttribute('tabindex')) fallback.setAttribute('tabindex', '-1');
          fallback.focus({ preventScroll: true });
        }
        return;
      }
      var heading = SECTIONS[section] ? root.querySelector('[data-cs-heading="' + section + '"]') : null;
      (heading || root).focus({ preventScroll: true });
    } catch (e) {}
  }

  function add(btn) {
    if (addInFlight || btn.getAttribute('aria-busy') === 'true') return;
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    // Second line of defence behind the snippet's own guards: never add either tote (CLAUDE.md 5).
    if (!variantId || variantId === 58288350953846 || variantId === 57929438200182) return;

    var card = btn.closest('[data-cs-card]');
    var root = btn.closest('[data-cart-suggestions]');
    var section = (card && card.getAttribute('data-section')) || '';
    var placement = (root && root.getAttribute('data-placement')) || (card && card.getAttribute('data-placement')) || '';
    var productId = card ? parseInt(card.getAttribute('data-product-id'), 10) : NaN;
    var title = (card && card.getAttribute('data-product-title')) || '';
    var size = btn.getAttribute('data-size') || '';
    var sizeSource = btn.getAttribute('data-size-source') || '';
    // Whether the cart was empty when the shopper tapped (the empty drawer and the empty /cart
    // show heroes only), so the A/B readout can tell those adds from upsells (#228 review).
    var cartEmpty = !!(root && root.getAttribute('data-cart-empty') === 'true');
    var sourceId = (card && card.id) || SOURCE;
    var region = regionFor(btn);
    var errorEl = card ? card.querySelector('[data-cs-error]') : null;
    var originalText = btn.textContent;

    if (errorEl) {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
    addInFlight = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = ADDING_LABEL;

    // Only while the button still carries OUR busy state. If the morph re-used this node it
    // has already given it the server's attributes and text, and those must not be undone.
    function restore() {
      if (btn.getAttribute('aria-busy') !== 'true') return;
      btn.removeAttribute('aria-busy');
      btn.textContent = originalText;
    }

    var succeeded = false;
    function fail() {
      addInFlight = false;
      restore();
      if (errorEl && errorEl.isConnected) {
        errorEl.textContent = ERROR_TEXT;
        errorEl.hidden = false;
      }
      announce(region, "Couldn't add " + title + ', try again');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: getSectionIds(),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          return { json: j, ok: r.ok };
        });
      })
      .then(function (resp) {
        var data = resp.json;
        if (!resp.ok || !data || (data.status && data.status >= 400)) {
          fail();
          return;
        }
        // From here the item IS in the cart: nothing below may report a failure.
        succeeded = true;
        addInFlight = false;
        var hadFocus = document.activeElement === btn;
        track('cart_suggestion_added', {
          section: section,
          product_id: isNaN(productId) ? null : productId,
          variant_id: variantId,
          size_source: sizeSource,
          placement: placement,
          cart_empty: cartEmpty
        });
        broadcast(data.sections, countFromSections(data.sections), sourceId);
        restore();
        if (hadFocus && !btn.isConnected) refocus(placement, section);
        announce(region, 'Added ' + title + (size ? ', size ' + size : ''));
      })
      .catch(function () {
        if (!succeeded) fail();
      });
  }

  // ── The size toggle ("M ▾" or "SIZE ▾"): the sizes under a suggestion ──
  // A disclosure, as the cart line's size toggle (#229, toggleSizePicker in
  // assets/component-cart-items.js): opening one closes any other suggestion's, and focus
  // stays on the toggle. A cart change re-renders the suggestions closed.
  function sizesFor(toggle) {
    var id = toggle.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function setSizesOpen(toggle, open) {
    var panel = sizesFor(toggle);
    if (!panel) return;
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
  }

  function toggleSizes(toggle, forceOpen) {
    var open = forceOpen || toggle.getAttribute('aria-expanded') !== 'true';
    document.querySelectorAll('[data-cs-toggle][aria-expanded="true"]').forEach(function (other) {
      if (other !== toggle) setSizesOpen(other, false);
    });
    setSizesOpen(toggle, open);
  }

  // Picking a size SELECTS it and never adds (Christian, 1 Oct 2026): the toggle and the
  // pressed size show it, ADD TO CART is pointed at that variant, the sizes close and focus
  // moves to ADD TO CART, the next step. size_source stays the estimate's ('cart' or
  // 'orders') when the shopper picks the estimated size again, and is 'chosen' otherwise.
  function selectSize(sizeBtn) {
    var card = sizeBtn.closest('[data-cs-card]');
    if (!card) return;
    var addBtn = card.querySelector('[data-cs-add]');
    var toggle = card.querySelector('[data-cs-toggle]');
    var title = card.getAttribute('data-product-title') || '';
    var size = sizeBtn.getAttribute('data-size') || '';
    var variantId = sizeBtn.getAttribute('data-variant-id') || '';
    card.querySelectorAll('[data-cs-size]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b === sizeBtn));
    });
    if (addBtn) {
      var estimate = addBtn.getAttribute('data-estimate-variant-id');
      addBtn.setAttribute('data-variant-id', variantId);
      addBtn.setAttribute('data-size', size);
      addBtn.setAttribute(
        'data-size-source',
        estimate && estimate === variantId ? addBtn.getAttribute('data-estimate-source') || 'chosen' : 'chosen'
      );
      addBtn.setAttribute('aria-label', 'Add to cart: ' + title + ', size ' + size);
    }
    if (toggle) {
      var label = toggle.querySelector('[data-cs-size-label]');
      if (label) label.textContent = size;
      toggle.setAttribute('aria-label', 'Size ' + size + ', change size of ' + title);
      setSizesOpen(toggle, false);
    }
    if (addBtn) addBtn.focus();
  }

  // Escape pressed INSIDE a suggestion block with one of its size rows open closes that row,
  // puts focus back on its toggle and goes no further, as the cart line's picker does (#229):
  // in the drawer the same key would also close the drawer, whose listener sits on
  // cart-drawer-component, an ancestor (assets/dialog.js), and preventDefault stops the modal
  // <dialog>'s own close. Capture phase, so this runs first. An Escape from anywhere else (the
  // shipping-protection info dialog, search, a cart line's own size picker) passes through
  // untouched, so it still closes what it was meant for (#228 review: measured on the preview,
  // the info dialog stayed open and a cart line's picker lost its Escape). A toggle that is not
  // drawn (left open in a closed drawer) has no layout boxes and does not count either.
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelectorAll('[data-cs-toggle][aria-expanded="true"]');
      for (var i = 0; i < open.length; i++) {
        var block = open[i].closest('[data-cart-suggestions]');
        if (!block || !(e.target instanceof Node) || !block.contains(e.target)) continue;
        if (!open[i].getClientRects().length) continue;
        e.preventDefault();
        e.stopPropagation();
        setSizesOpen(open[i], false);
        open[i].focus();
        return;
      }
    },
    true
  );

  // One delegated handler for every size toggle, size button and ADD TO CART, in the drawer
  // and on /cart, including those morphed in after a cart change.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var toggle = t.closest('[data-cs-toggle]');
    if (toggle) {
      e.preventDefault();
      toggleSizes(toggle);
      return;
    }
    var sizeBtn = t.closest('[data-cs-size]');
    if (sizeBtn) {
      e.preventDefault();
      if (!sizeBtn.disabled) selectSize(sizeBtn);
      return;
    }
    var btn = t.closest('[data-cs-add]');
    if (!btn) return;
    e.preventDefault();
    // No size chosen yet (no estimate): open the sizes and put focus on the first in stock,
    // instead of adding. Nothing is sent.
    if (!btn.getAttribute('data-variant-id')) {
      var card = btn.closest('[data-cs-card]');
      var cardToggle = card && card.querySelector('[data-cs-toggle]');
      if (cardToggle) {
        toggleSizes(cardToggle, true);
        var panel = sizesFor(cardToggle);
        var first = panel && panel.querySelector('[data-cs-size]:not([disabled])');
        if (first) first.focus();
      }
      return;
    }
    add(btn);
  });

  // ── cart_suggestions_shown: once per drawer open, once per /cart load ──
  // Counts come from the snippet's data-ctl-count / data-hero-count, read at that moment.
  // Sent with zeros too: how often there was nothing to suggest is part of the measure.
  // cart_empty separates an empty cart (heroes only, up to 4 in the drawer) from a filled one
  // that found no pairing (#228 review): both send complete_the_look 0.
  function reportShown(placement) {
    var root = document.querySelector('[data-cart-suggestions][data-placement="' + placement + '"]');
    if (!root) return;
    trackWhenReady('cart_suggestions_shown', {
      placement: placement,
      cart_empty: root.getAttribute('data-cart-empty') === 'true',
      complete_the_look: parseInt(root.getAttribute('data-ctl-count'), 10) || 0,
      we_think_youll_love: parseInt(root.getAttribute('data-hero-count'), 10) || 0
    });
  }

  // assets/dialog.js dispatches `dialog:open` on the component itself, without bubbling, so
  // it is caught in the capture phase, and only for the cart drawer (other dialogs send it
  // too). It fires on every open, including the automatic one after an Add elsewhere.
  document.addEventListener(
    'dialog:open',
    function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('cart-drawer-component')) return;
      reportShown('drawer');
    },
    true
  );

  function onReady() {
    pageRegion(); // exists before its first message, which screen readers need
    reportShown('page'); // only /cart renders the page placement; the drawer is not on /cart
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();
})();
